import ProfileEditPanel from "PFApp/profiles/edit/profile_edit_panel";
import { getProfileSectionText } from "PFApp/profiles/edit/profile_edit_sections";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useSignOut } from "PFApp/use_session";
import { Button } from "PFComponents/button";
import { suspendProfile } from "PFCore/services/profile";
import { Profile } from "PFTypes";
import { useTranslation } from "react-i18next";

type DeleteUserSectionProps = {
  profile: Profile;
};

const DeleteUserSection = ({ profile }: DeleteUserSectionProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "edit.sections" });
  const { signOut } = useSignOut();
  const handleSignOut = () => signOut();
  const { showGrowl } = useGrowlStoreActions();
  const handleRemoveProfile = () => {
    if (window.confirm(t("deleteUser.sureDeleteAccount"))) {
      suspendProfile(profile.id).then(() => {
        showGrowl({ message: t("deleteUser.accountDeleted") });
        setTimeout(handleSignOut, 3000);
      });
    }
  };

  return (
    <ProfileEditPanel title={getProfileSectionText("delete_user")}>
      <Button kind="danger" onClick={handleRemoveProfile}>
        {t("deleteUser.deleteMyAccount")}
      </Button>
    </ProfileEditPanel>
  );
};

export default DeleteUserSection;
